import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { BsEyeSlash, BsEyeSlashFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { callAPI } from "../../../../axios";
import ChangePasswordConfirmPopUp from "./ChangePasswordConfirmPopUp";
import BasicModal from "../../../core/BaseComponents/Modal";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [toggle, setToggleEye] = useState(true);
  const [confirmToggle, setConfirmToggle] = useState(true);
  const [apiResponse, setApiResponse] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange'
  });

  const onSubmit = () => {
    setIsModalOpen(true);
  };

  const newPasswordEye = () => {
    setToggleEye(!toggle);
  };

  const newConfirmPasswordEye = () => {
    setConfirmToggle(!confirmToggle);
  };

  const handleCancelButton = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  const handleClose = () => {
    setIsModalOpen(false)
  };

  const handleConfirm = () => {
    setIsModalOpen(false);
    let url = "/user/change-password";
    callAPI(url, "PUT", { password: watch("password") })
      .then((response) => {
        setApiResponse(response?.message);
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  const logout = () => {
    localStorage.clear();
    window.location.replace('/login');
  }

  return (
    <>
      <div className="breadcrumb">
        <ul>
          <li>
            <Link to="/hms/ConfigurationNewHotel">Dashboard </Link>{" "}
            <span className="arrow-color"> &gt; </span>
          </li>
          <li>Change Password</li>
        </ul>
      </div>
      <div className="sub-header">
        <h1>Change Password</h1>
      </div>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="create-edit-user">
          <div className="row">
            <div className="form-group col-4 position-relative">
              <label htmlFor="password">New Password<span className="required">*</span></label>
              {!toggle ? (
                <BsEyeSlashFill
                  className="on-off-eye-changepassword"
                  onClick={newPasswordEye}
                />
              ) : (
                <BsEyeSlash
                  onClick={newPasswordEye}
                  className="on-off-eye-changepassword"
                />
              )}
              <input
                id="password"
                type={toggle ? "password" : "text"}
                className="form-control"
                placeholder="Enter password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 4,
                    message: "Password must be at least 4 characters"
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9@#$\-!]+$/,
                    message: "Password must be Alphanumeric and can include @, #, $, -, !"
                  }
                })}
              />
              {errors.password && (
                <small className="required">{errors.password.message}</small>
              )}
            </div>
            <div className="form-group col-4 position-relative">
              <label htmlFor="confirmPassword">Confirm Password<span className="required">*</span></label>
              {!confirmToggle ? (
                <BsEyeSlashFill
                  className="on-off-eye-changepassword"
                  onClick={newConfirmPasswordEye}
                />
              ) : (
                <BsEyeSlash
                  onClick={newConfirmPasswordEye}
                  className="on-off-eye-changepassword"
                />
              )}
              <input
                id="confirmPassword"
                type={confirmToggle ? "password" : "text"}
                className="form-control"
                placeholder="Enter Confirm password"
                {...register("confirmPassword", {
                  required: "Confirm Password is required",
                  validate: value => 
                    value === watch("password") || "Password and confirm password not matched"
                })}
              />
              {errors.confirmPassword && (
                <small className="required">
                  {errors.confirmPassword.message}
                </small>
              )}
            </div>
          </div>

          <div className="col-8 text-end pe-2">
            <button
              type="button"
              className="cancel-btn"
              onClick={handleCancelButton}
            >
              Cancel
            </button>
            <button type="submit" className="create-btn">
              Change Password
            </button>
          </div>
        </div>
      </form>
      <ChangePasswordConfirmPopUp
        modalOpen={isModalOpen}
        modalClose={handleClose}
        modalConfirm={handleConfirm}
      />
      <BasicModal
        popupOpen={apiResponse !== ""}
        bodyMessage={apiResponse}
        logo={"/Images/approve-qc.png"}
        footer={{
          secondaryButton: {
            action: logout,
            buttonName: "Login"
          },
        }}
      />
    </>
  );
};

export default ChangePassword;
